module.exports = __webpack_public_path__ + "img/logo2.5009882f.png";